import { cn } from '@/lib/cn';

type AccentProps = {
  /** Texte dont la partie après `|` devient le mot d'accent. Sans `|`, rien n'est accentué. */
  text: string;
  /** `surligne` sur clair ; `ciel` colore le mot, réservé aux fonds encre. */
  variant?: 'surligne' | 'ciel';
};

/**
 * Titre avec mot d'accent en Instrument Serif italique — un mot ou deux,
 * jamais un paragraphe (charte § 07).
 */
export function Accent({ text, variant = 'surligne' }: AccentProps) {
  const [before, accent] = text.split('|');

  return (
    <>
      {before}
      {accent && (
        <span className={cn('accent', variant === 'surligne' ? 'surligne' : 'text-ciel')}>
          {accent}
        </span>
      )}
    </>
  );
}
